import { apiConstants } from '../../apiConstant'
import { serviceCallAuth } from '../../serviceCall'

export const resetPassword = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCallAuth({
      url: apiConstants.AUTH.RESET_PASSWORD,
      method: 'put',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
